var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.15,
    height: 12.152,
    viewBox: "0 0 12.15 12.152",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f242d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M119.309.807a1.864,1.864,0,0,0-2.636,0l-7.39,7.39a.414.414,0,0,0-.106.182l-.972,3.508a.414.414,0,0,0,.51.51l3.508-.972a.414.414,0,0,0,.182-.106l7.39-7.39a1.866,1.866,0,0,0,0-2.636Zm-9.124,7.659,6.048-6.048,1.951,1.951-6.048,6.048Zm-.39.782,1.558,1.558-2.156.6Zm9.413-5.9-.439.439L116.82,1.832l.439-.439a1.035,1.035,0,0,1,1.464,0l.486.486A1.037,1.037,0,0,1,119.21,3.343Zm0,0",
    transform: "translate(-108.19 -0.261)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c4a11f5ba11a80ab9f51cd041b4e924c.svg";
export { ForwardRef as ReactComponent };